import React, { Component } from "react";
import { Container, Header, Tab, Accordion, Icon } from "semantic-ui-react";
import { setTitle, setMetaDescription } from '../../util';
import { Link } from "react-router-dom";
import MessageModal from '../support/MessageModal';

class Faqs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      activeModal: false,
      tvVisible: false,
      activeIndex: -1,
      messageModal: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onTabChange = this.onTabChange.bind(this);
    this.openMessageModal = this.openMessageModal.bind(this);
    this.closeMessageModal = this.closeMessageModal.bind(this);
  }

  openMessageModal(e) {

    e.preventDefault();
    this.setState({
      messageModal: true
    });
  }

  closeMessageModal() {

    this.setState({
      messageModal: false
    });
  }

  openModal(modalName) {
    this.setState({
      activeModal: modalName,
      tvVisible: (modalName === 'tv')
    });
  }

  closeModal() {
    this.setState({
      tvVisible: false
    });

    setTimeout(() => {
      this.setState({
        activeModal: false
      });
    }, 500);
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }
  componentDidMount() {
    document.title = setTitle(this.props.title);
    setMetaDescription(this.props.description);
  }

  onTabChange(event, data) {
    this.setState({ activeIndex: -1 })
  }

  render() {
    const { activeIndex, messageModal } = this.state

    const panes = [
      {
        menuItem: 'INTERNET',
        render: () =>
          <Tab.Pane>
            <Accordion fluid styled>
              <div className="accordion__block" key="i-0">
                <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  How does FibreStream Internet work?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 0} className="expand">
                  <div className="space-pad">
                    <p>
                      Plug a computer or wireless router into the FibreStream-installed data jack and you are instantly online.
                  </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="i-1">
                <Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  How does FibreStream Wi-Fi work?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 1} className="expand">
                  <div className="space-pad">
                    <p>
                      You need a Wi-Fi router. We recommend purchasing a FibreStream router however you are welcome to use your own or buy your own. All standalone routers are compatible. Modems are not compatible.
              </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="i-2">
                <Accordion.Title active={activeIndex === 2} index={2} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Can I use my own router?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 2} className="expand">
                  <div className="space-pad">
                    <p>
                      Yes you may use your own router. Please note you will be responsible for the configuration and support of your own router.  Our connection type is DHCP or Dynamic IP.  If you are not comfortable setting up your own router, we recommend that you purchase a preconfigured router from FibreStream.
              </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="i-3">
                <Accordion.Title active={activeIndex === 3} index={3} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Where is FibreStream Internet installed?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 3} className="expand">
                  <div className="space-pad">
                    <p>
                      You can choose any phone jack in your unit and our technician will convert the phone jack into our FibreStream data jack. If you already have FibreStream installed in your unit and would like to move the data jack to a new location, a FibreStream technician visit will be required.
              </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="i-4">
                <Accordion.Title active={activeIndex === 4} index={4} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Is there only one jack active in my unit?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 4} className="expand">
                  <div className="space-pad">
                    <p>
                      Yes, only one jack is active in your unit at a time.
              </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="i-5">
                <Accordion.Title active={activeIndex === 5} index={5} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Do I need a modem?

            </Accordion.Title>
                <Accordion.Content active={activeIndex === 5} className="expand">
                  <div className="space-pad">
                    <p>
                      No. FibreStream uses modem-less technology for the fastest speeds possible.
              </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="i-6">
                <Accordion.Title active={activeIndex === 6} index={6} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Does FibreStream Internet service ever slow down?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 6} className="expand">
                  <div className="space-pad">
                    <p>
                    No. FibreStream guarantees your speeds 24 hours a day, 7 days a week.
              </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="i-7">
                <Accordion.Title active={activeIndex === 7} index={7} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Are all packages unlimited?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 7} className="expand">
                  <div className="space-pad">
                    <p>
                    Yes. All of our packages are unlimited, so you never have to worry about going over a limit.
              </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="i-8">
                <Accordion.Title active={activeIndex === 8} index={8} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Does FibreStream limit or throttle Internet traffic?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 8} className="expand">
                  <div className="space-pad">
                    <p>
                      No. FibreStream does not throttle or block any Internet traffic.
              </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="i-9">
                <Accordion.Title active={activeIndex === 9} index={9} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Do you service houses?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 9} className="expand">
                  <div className="space-pad">
                    <p>
                      No. FibreStream is only available in select condominiums and apartments.
              </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="i-10">
                <Accordion.Title active={activeIndex === 10} index={10} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  How can I get FibreStream in my building?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 10} className="expand">
                  <div className="space-pad">
                    <p>
                      You can speak to your building management or condo board and ask them to get in touch with us at getfibre@fibrestream.ca.
              </p>
                  </div>
                </Accordion.Content>
              </div>

            </Accordion>
          </Tab.Pane>
      },
      {
        menuItem: 'ACCOUNT',
        render: () =>
          <Tab.Pane>
            <Accordion fluid styled>
              <div className="accordion__block" key="a-0">
                <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  Is there a contract?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 0} className="expand">
                  <div className="space-pad">
                    <p>
                    There are no contracts with any of our services.
              </p>
                  </div>
                </Accordion.Content>
              </div>

              <div className="accordion__block" key="a-1">
                <Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  What if I want to cancel?
            </Accordion.Title>
                <Accordion.Content active={activeIndex === 1} className="expand">
                  <div className="space-pad">
                    <p>
                      You can cancel any time with no notice required. Simply <Link className="text-prime" to={'support'} target='_blank' rel="noopener noreferrer" >contact us</Link>.
              </p>
                  </div>
                </Accordion.Content>
              </div>

            </Accordion>
          </Tab.Pane>
      },
      {
        menuItem: 'SUPPORT',
        render: () =>
          <Tab.Pane>
            <Accordion fluid styled>
              <div className="accordion__block" key="a-0">
                <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
                  <Icon name='dropdown' />
                  How can I get support?
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 0} className="expand">
                  <div className="space-pad">
                    <p>
                    You can visit our <a href="https://support.fibrestream.ca/">support centre</a> or you can <a className="cursor-pointer" onClick={this.openMessageModal}>contact us</a>.
                    </p>
                  </div>
                </Accordion.Content>
              </div>
            </Accordion>
          </Tab.Pane>
      },
    ];

    return (
      <section className="space faqs accordion__custom">
        <Container>
          <Header as="h1" className="display-1 itc-mdbold text-uc" textAlign='center'>FAQs</Header>

          <Tab menu={{ fluid: true, vertical: true, tabular: true }} panes={panes} onTabChange={this.onTabChange} />

        </Container>
        <MessageModal open={messageModal} closeMessageModal={this.closeMessageModal} />
      </section>
    )
  }
}

export default Faqs;


// WEBPACK FOOTER //
// ./src/components/faqs/Faqs.js